@import (reference) '../../../../../constants/spacing.module.less';

.order-items-section-content {
  padding: @space-16;
}

.order-items-section-header {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
